import { render } from "./serviciosComponent.vue?vue&type=template&id=87d18d52"
import script from "./serviciosComponent.vue?vue&type=script&lang=js"
export * from "./serviciosComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__